import optimizelySDK from '@optimizely/optimizely-sdk';
import {v4 as randomUID} from "uuid";

export async function initializeOptimizely(appConfig, customerData) {
    // Create a user and decide a flag rule (such as an A/B test) for them
    const optimizelyClientInstance = optimizelySDK?.createInstance({
        sdkKey: appConfig?.optimizelyKey,
    });
    return optimizelyClientInstance.onReady().then(() => {
        // optimizely is ready to use, with datafile downloaded from the Optimizely CDN

        let userID;
        if (document.cookie.indexOf('prequalLanding') !== -1) {
            // Get the value of the prequalLanding cookie
            // Perform actions with the cookie value
            userID = document.cookie
                .split('; ')
                .find(row => row.startsWith('prequalLanding='))
                .split('=')[1]
        } else {
            // Generate a random UUID
            const randomUUID = randomUID()

            // Set expiration date for the cookie
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 14);

            // Set the prequalLanding cookie with the random UUID
            document.cookie = `prequalLanding=${randomUUID}; expires=${expirationDate.toUTCString()}`;

            // Perform actions with the newly set cookie
            userID = randomUUID
        }

        return optimizelyClientInstance.createUserContext(userID, {prequal_uuid: customerData.uuid});
    })

}
